import React, { useState } from 'react';
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend,
} from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { IconButton, Tooltip as MuiTooltip, Dialog, DialogTitle, DialogContent, DialogActions, Button, Box } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import { useData } from '../context/DataContext';

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend, ChartDataLabels);

const DiasPromedioEntregaBar = ({ selectedIndustries = [], onIndustryClick = () => {} }) => {
  const [infoOpen, setInfoOpen] = useState(false);
  const { getSupplierDeliveries, dataReady } = useData();

  // Get data from Excel (3 years) - Q9: Entregas a tiempo de proveedor
  const excelData = dataReady ? getSupplierDeliveries() : { labels: [], data2022: [], data2023: [], data2024: [] };

  // Use Excel data or fallback
  const allLabels = excelData.labels.length > 0
    ? excelData.labels
    : ['Sector salud/ Farmacéuticas', 'Servicios Logísticos', 'Alimentos', 'Construcción', 'Automotriz', 'Manufactura', 'Retail'];

  const allData2022 = excelData.data2022.length > 0 ? excelData.data2022 : [90, 91, 91, 85, 93, 94, 91];
  const allData2023 = excelData.data2023.length > 0 ? excelData.data2023 : [100, 93, 92, 91, 89, 85, 80];
  const allData2024 = excelData.data2024.length > 0 ? excelData.data2024 : [95, 92, 93, 90, 91, 88, 85];

  const labels = selectedIndustries.length > 0 ? selectedIndustries : allLabels;

  const getValuesForLabels = (allValues) => labels.map((label) => {
    const index = allLabels.indexOf(label);
    return index !== -1 ? allValues[index] : 0;
  });

  const chartData = {
    labels: labels,
    datasets: [
      {
        label: '2023',
        data: getValuesForLabels(allData2022),
        backgroundColor: '#A2AEBB',
        borderColor: '#fff',
        borderWidth: 1,
      },
      {
        label: '2024',
        data: getValuesForLabels(allData2023),
        backgroundColor: '#476A8E',
        borderColor: '#fff',
        borderWidth: 1,
      },
      {
        label: '2025',
        data: getValuesForLabels(allData2024),
        backgroundColor: '#1F3D58',
        borderColor: '#fff',
        borderWidth: 1,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    layout: {
      padding: {
        top: 40,
        bottom: 30,
        left: 10,
        right: 10,
      },
    },
    plugins: {
      legend: {
        position: 'top',
      },
      tooltip: {
        callbacks: {
          label: (context) => `${context.dataset.label}: ${context.raw}%`,
        },
      },
      datalabels: {
        color: '#000',
        font: {
          weight: 'bold',
          size: 9,
        },
        formatter: (value) => `${value}%`,
        anchor: 'end',
        align: 'top',
        offset: (context) => {
          // Stagger labels vertically to avoid overlap
          return context.datasetIndex === 0 ? 2 : context.datasetIndex === 1 ? 12 : 22;
        },
      },
    },
    scales: {
      x: {
        title: {
          display: true,
          text: 'Industria',
          font: {
            size: 12,
          },
        },
        ticks: {
          autoSkip: false,
          font: {
            size: 12,
          },
        },
      },
      y: {
        title: {
          display: true,
          text: '% de entregas a tiempo',
          font: {
            size: 12,
          },
        },
        beginAtZero: true,
        max: 110,
        ticks: {
          stepSize: 10,
          font: {
            size: 12,
          },
        },
      },
    },
  };

  const infoContent = {
    formula: 'Entregas a tiempo de proveedor = (Total de órdenes recibidas a tiempo / Total de órdenes realizadas a proveedores) × 100',
    description: 'Mide el porcentaje de órdenes de compra recibidas en tiempo.',
  };

  return (
    <div style={{ maxWidth: '800px', height: '500px', margin: '0 auto', padding: '20px' }}>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <MuiTooltip title="Información de la gráfica">
          <IconButton onClick={() => setInfoOpen(true)}>
            <InfoIcon />
          </IconButton>
        </MuiTooltip>
      </Box>
      <Bar data={chartData} options={options} />
      <Dialog open={infoOpen} onClose={() => setInfoOpen(false)}>
        <DialogTitle>Información de la Gráfica</DialogTitle>
        <DialogContent>
          <p><strong>Fórmula:</strong> {infoContent.formula}</p>
          <p><strong>Descripción:</strong> {infoContent.description}</p>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setInfoOpen(false)} color="primary">
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default DiasPromedioEntregaBar;
